import * as React from "react";
import { BaseIconProps } from "./BaseIconProps";
import { styledTheme } from "../../theme/theme";

export const TipIcon = (props: TipIconProps): JSX.Element => {
  const { width, height, isActive } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6ZM2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6C10 8.20914 8.20914 10 6 10C3.79086 10 2 8.20914 2 6ZM6 3C6.27614 3 6.5 3.22386 6.5 3.5C6.5 3.77614 6.27614 4 6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3ZM6.5 9V5H5.5V9H6.5Z"
        fill={isActive ? "white" : "#6E7D92"}
      />
    </svg>
  );
};
type TipIconProps = BaseIconProps & {
  isActive?: boolean;
};
TipIcon.defaultProps = {
  width: "25",
  height: "25",
  color: styledTheme.newColors.grayscale.white,
};
